import React from "react";
import app from "../assets/app-store.png";
import play from "../assets/play-store.png";
import banner from "../assets/mobile-slide-view.webp";
import { useNavigate } from "react-router-dom";

const DownloadApp = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-[#F8FCFA] flex flex-col justify-center  items-center h-screen bg-[#16A951]/10">
      <div className="w-full px-6 xl:px-0 xl:w-2xl">
        <div className="bg-[#16A951] rounded-2xl z-0">
          <div className="md:px-16 lg:px-32 xl:px-60 pt-8 md:pt-14 text-white px-4">
            <div className="font-bold text-3xl sm:text-4xl text-center mb-2">
              Get the App
            </div>{" "}
            <div className="font-lexend-deca font-normal text-xs sm:text-lg text-white text-center mb-4">
              Download now to explore and connect with your desired entities
              effortlessly.
            </div>{" "}
            <div className="flex gap-2 sm:gap-4  md:flex-row justify-center items-center pb-8 md:pb-32">
              <div className=" md:mb-0 md:mr-4">
                <a
                  href="https://apps.apple.com/sb/app/kaha-app/id6470139955"
                  target="_blank"
                >
                  <img src={app} alt="App Store" />
                </a>
              </div>
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=com.kaha_hits.kaha"
                  target="_blank"
                >
                  <img src={play} alt="Play Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className=" ml-[1%] lg:ml-[15%]  md:-mt-20 z-10 hidden md:block">
          <img src={banner} alt="Mobile Slide View" loading="lazy" />
        </div>
        
        {/* Go to Home Button */}
        <div className="flex justify-center mt-8 sm:mt-12">
          <button
            onClick={() => navigate('/')}
            className="bg-[#16A951] hover:bg-[#128a3d] text-white font-semibold px-6 py-3 rounded-md transition-colors duration-300 text-sm sm:text-base"
          >
            Go to Home Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
